import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { OrdersOverdue } from '../types/OrderOverdues'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'

type OrderClientObservation = PaginatedParams & {
  userId: string
}

const loadOrderClientObservations = (
  data: OrderClientObservation
): PaginatedResponse<OrdersOverdue> => {
  const { page = 1, limit = 10 } = data
  return axios.get(`/orders/customers/${data.userId}/observation`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderClientObservations(query: OrderClientObservation) {
  return useQuery(
    ['orderClientObservation', query],
    () => loadOrderClientObservations(query),
    {
      enabled: !!query.userId,
      onError: () =>
        toast.error('Não foi possível carregar as observações', {
          toastId: 'loadOrderObservation'
        })
    }
  )
}
